// extracted by mini-css-extract-plugin
export default {"teacherShowerContainer":"TeacherShower_teacherShowerContainer__wuTk3","teacherLink":"TeacherShower_teacherLink__XptFU"};